export default __webpack_public_path__ + "static/media/grey_redo.4ef5d01b.svg";